export enum BannerMessageType {
  Informational = 0,
  Warning = 1,
  Critical = 2,
}

export interface BannerEnvironment {
  autoTerminate: boolean;
  customMessage: string;
  customUrl: string;
  display: boolean;
  messageType: BannerMessageType;
}

function parseBoolean(value: boolean | string | null | undefined, fallback: boolean): boolean {
  if (value === true || value === 'true') {
    return true;
  }

  if (value === false || value === 'false') {
    return false;
  }

  return fallback;
}

function parseMessageType(
  value: number | string | null | undefined,
  fallback: BannerMessageType
): BannerMessageType {
  const parsed = Number(value);

  if (parsed === BannerMessageType.Warning) {
    return BannerMessageType.Warning;
  }

  if (parsed === BannerMessageType.Critical) {
    return BannerMessageType.Critical;
  }

  if (parsed === BannerMessageType.Informational) {
    return BannerMessageType.Informational;
  }

  return fallback;
}

export function createBannerEnvironment(): BannerEnvironment {
  return {
    autoTerminate: parseBoolean(window.bannerAutoTerminate, false),
    customMessage: window.bannerCustomMessage || '',
    customUrl: window.bannerCustomUrl || '',
    display: parseBoolean(window.bannerDisplay, false),
    messageType: parseMessageType(window.bannerMessageType, BannerMessageType.Informational),
  };
}
